import React from "react";
import Close from "../Reutilizaveis/CloseButton";
import PassVerification from "../../Utils/passVerification";
import Fade from "@material-ui/core/Fade";
import "./styles.scss";
const PassVerificationWithModal = ({
  newPassword,
  setApproved,
  confirmNewPassword,
  setRegras,
  regras,
}) => {
  return (
    <>
      <div
        className="first-access-password__checkPassword"
        style={{ display: "none" }}
      >
        <PassVerification
          password={newPassword}
          setApproved={setApproved}
          confirmPassword={confirmNewPassword}
        />
      </div>

      {regras && (
        <Fade>
          <>
            <div className="centralized-column modalCheckPassword">
              <span className="modalCheckPassword__title">
                Regras para construção da senha:
              </span>
              <span
                onClick={() => {
                  setRegras(false);
                }}
                className="modalCheckPassword__closeModal"
              >
                <Close tamanho="20px" tamanhoIcone="10px" corBackground={'#fff'} />
              </span>
              <div className="first-access-password__checkPassword">
                <PassVerification
                  password={newPassword}
                  setApproved={setApproved}
                  confirmPassword={confirmNewPassword}
                />
              </div>
            </div>
          </>
        </Fade>
      )}
    </>
  );
};

export default PassVerificationWithModal;
